import { render, staticRenderFns } from "./GroupMoveSelector.vue?vue&type=template&id=b612f188&scoped=true&"
import script from "./GroupMoveSelector.vue?vue&type=script&lang=js&"
export * from "./GroupMoveSelector.vue?vue&type=script&lang=js&"
import style0 from "./GroupMoveSelector.vue?vue&type=style&index=0&id=b612f188&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b612f188",
  null
  
)

export default component.exports